export default "__VITE_ASSET__93f7f7dd__"